
export default function PapilomaCenterSection() {
  return (
    <section id="urethral-reconstruction" className="py-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-blue-100 rounded-full px-6 py-2 mb-6">
            <i className="ri-hospital-line text-blue-600 mr-2"></i>
            <span className="text-blue-800 font-semibold">Centro de Excelencia</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Centro de Cirugía Uretral Reconstructiva
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Centro especializado en el diagnóstico y tratamiento de estenosis uretrales, 
            cicatrices y lesiones uretrales con técnicas reconstructivas avanzadas.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
          <div>
            <img 
              src="https://drjromero-otero.com/wp-content/uploads/2024/10/uretroplastia.webp"
              alt="Centro de Reconstrucción Uretral - Cirugía Reconstructiva"
              className="w-full h-80 object-cover object-center rounded-2xl shadow-2xl"
            />
          </div>
          
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Reconstrucción Uretral Avanzada
            </h3>
            <p className="text-gray-600 mb-8 leading-relaxed">
              El Dr. Eduardo Cabeza Bucio es experto en cirugía reconstructiva uretral, 
              utilizando técnicas microquirúrgicas de última generación para tratar 
              estenosis, cicatrices y defectos congénitos de la uretra.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-microscope-line text-xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Diagnóstico Preciso</h4>
                  <p className="text-gray-600">Uretroscopia de alta definición y estudios flujo urinario para evaluación exacta.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-cut-line text-xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Cirugía Microquirúrgica</h4>
                  <p className="text-gray-600">Técnicas reconstructivas para restaurar la función y estética uretral.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-heart-pulse-line text-xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Recuperación Optimizada</h4>
                  <p className="text-gray-600">Protocolos de rehabilitación personalizados para recuperación completa y rápida.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Tratamientos de Reconstrucción Uretral
          </h3>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-scissors-cut-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-3">Uretroplastia Primaria</h4>
              <p className="text-gray-600 text-sm">
                Tratamientos diseñados para resolver obstrucciones uretrales de manera eficaz y segura..
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-plant-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-3">Recontrucción especializada</h4>
              <p className="text-gray-600 text-sm">
                Técnicas avanzadas orientadas a restaurar la función uretral en casos que requieren un abordaje más complejo.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-3">Cirugía de Revisión</h4>
              <p className="text-gray-600 text-sm">
                Tratamiento de estenosis recurrentes y complicaciones 
                postquirúrgicas con técnicas avanzadas.
              </p>
            </div>
          </div>
          
          <div className="mt-8 text-center">
            <a 
              href="https://api.whatsapp.com/send/?phone=+523317097105&text=Hola+Dr.+Eduardo+Cabeza+Bucio%2C+me+gustar%C3%ADa+agendar+una+consulta&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 transition-colors whitespace-nowrap cursor-pointer inline-block"
              style={{ backgroundColor: '#168B98' }}
            >
              Consulta de Reconstrucción Uretral
            </a>
          </div>
        </div>
        
        <div className="mt-16 bg-gradient-to-r from-blue-100 to-cyan-100 rounded-2xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Expertise del Dr. Eduardo Cabeza Bucio
            </h3>
            <p className="text-gray-700 mb-6 max-w-3xl mx-auto">
              Con más de 10 años de experiencia en cirugía reconstructiva urológica, 
              el Dr. Cabeza Bucio ha realizado exitosamente cientos de procedimientos 
              de reconstrucción uretral, devolviendo la calidad de vida a pacientes 
              con estenosis complejas y traumatismos uretrales.
            </p>
            <div className="grid md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">200+</div>
                <div className="text-sm text-gray-600">Cirugías Reconstructivas</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">90%</div>
                <div className="text-sm text-gray-600">Tasa de Éxito</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">10+</div>
                <div className="text-sm text-gray-600">Años de Experiencia</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">0</div>
                <div className="text-sm text-gray-600">Recidivas en Casos Selectos</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
